import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=3bcf16f9&scoped=true&"
import script from "./newUser.ts?vue&type=script&lang=ts&"
export * from "./newUser.ts?vue&type=script&lang=ts&"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=3bcf16f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf16f9",
  null
  
)

export default component.exports